export default "__VITE_ASSET__B9L03vlz__"